import React from 'react';
import { DEEP_HELP, FILTER_COLUMNS, MONTHS, fieldShows } from './constants';
import styles from './ProductFinder.module.css';

// The filter columns for one tab (Product / Competitors / Sales). Blank = no limit.
const FiltersForm = ({ tab, values, onChange, deepData, market }) => {
  const set = (key, v) => onChange({ ...values, [key]: v });
  const setBound = (key, i, v) => {
    const cur = values[key] || ['', ''];
    set(key, i === 0 ? [v, cur[1]] : [cur[0], v]);
  };
  const toggle = (key, opt) => {
    const cur = values[key] || [];
    set(key, cur.includes(opt) ? cur.filter((x) => x !== opt) : [...cur, opt]);
  };

  const loadFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    file.text().then((text) => {
      const cur = values.identifiers ? `${values.identifiers}\n` : '';
      set('identifiers', cur + text);
    });
    e.target.value = '';
  };

  const renderField = (f) => {
    const disabled = f.deep && !deepData;
    let label = tab === 'oos' && f.oosLabel ? f.oosLabel : f.label;
    if (f.money) label += ` (${market.currency.trim()})`;
    const help = [f.deep ? DEEP_HELP : '', f.help || ''].filter(Boolean).join(' ');
    const v = values[f.key];
    let control;
    switch (f.type) {
      case 'range':
      case 'signed': {
        const step = f.priceStep ? market.step : (f.step || 1);
        const r = v || ['', ''];
        control = (
          <div className={styles.rangeRow}>
            {[0, 1].map((i) => (
              <input
                key={i}
                type="number"
                className={styles.input}
                placeholder={(i === 0 ? 'Min' : 'Max') + (f.type === 'signed' ? ' %' : '')}
                min={f.type === 'signed' ? undefined : 0}
                step={step}
                value={r[i]}
                disabled={disabled}
                onChange={(e) => setBound(f.key, i, e.target.value)}
              />
            ))}
          </div>
        );
        break;
      }
      case 'dates': {
        const r = v || ['', ''];
        control = (
          <div className={styles.rangeRow}>
            {[0, 1].map((i) => (
              <input key={i} type="date" className={styles.input} value={r[i]} disabled={disabled}
                onChange={(e) => setBound(f.key, i, e.target.value)} />
            ))}
          </div>
        );
        break;
      }
      case 'multi':
      case 'months': {
        const opts = f.type === 'months' ? MONTHS : f.options;
        const cur = v || [];
        control = (
          <div className={styles.toggleRow}>
            {opts.map((o) => (
              <button
                key={o}
                type="button"
                disabled={disabled}
                className={cur.includes(o) ? `${styles.toggle} ${styles.toggleOn}` : styles.toggle}
                onClick={() => toggle(f.key, o)}
              >
                {o}
              </button>
            ))}
          </div>
        );
        break;
      }
      case 'select':
        control = (
          <select className={styles.input} value={v || 'All'} disabled={disabled} onChange={(e) => set(f.key, e.target.value)}>
            {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        );
        break;
      case 'identifiers':
        control = (
          <>
            <textarea className={styles.input} rows={3} placeholder={f.placeholder} value={v || ''}
              onChange={(e) => set(f.key, e.target.value)} />
            <input type="file" accept=".txt,.csv" className={styles.fileInput} onChange={loadFile} />
          </>
        );
        break;
      default:
        control = (
          <input className={styles.input} placeholder={f.placeholder} value={v || ''} disabled={disabled}
            onChange={(e) => set(f.key, e.target.value)} />
        );
    }
    return (
      <div key={f.key} className={`${styles.field} ${disabled ? styles.fieldDisabled : ''}`} title={help || undefined}>
        <span className={styles.label}>{label}{help && <span className={styles.helpDot}> ⓘ</span>}</span>
        {control}
      </div>
    );
  };

  return (
    <div className={styles.filterGrid}>
      {FILTER_COLUMNS.map((col) => (
        <div key={col.title}>
          <h4 className={styles.colTitle}>{col.title}</h4>
          {col.title === 'Competitors' && (
            <p className={styles.caption}>{deepData ? 'Seller = buy box seller.' : 'Seller filters need Deep data.'}</p>
          )}
          {col.fields.filter((f) => fieldShows(f, tab)).map(renderField)}
        </div>
      ))}
    </div>
  );
};

export default FiltersForm;
